import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

const url = 'student-update-requests';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function pass(id) {
  return post({
    url: `${url}/${id}`,
  });
}

export function reject(id, data) {
  return patch({
    url: `${url}/${id}`,
    data,
  });
}

export function revoke(id, data) {
  return del({
    url: `${url}/${id}`,
    data,
  });
}
